import {
  Component,
  ViewChild,
  TemplateRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { ITab } from 'src/app/shared/components/tab-control/tab-control.component';

@Component({
    selector: 'app-dashboard-cl',
    templateUrl: './dashboard-cl.component.html',
    styleUrls: ['./dashboard-cl.component.scss'],
    standalone: false
})
export class DashboardClComponent implements AfterViewInit {
  @ViewChild('attributesReportTabContent')
  attributesReportTabContent!: TemplateRef<any>;
  @ViewChild('alertReportTabContent') alertReportTabContent!: TemplateRef<any>;

  tabs: ITab[] = [];

  constructor(private readonly changeDetector: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.tabs = [
      {
        label: $localize`:@@attributesReport:Informe de atributos`,
        component: this.attributesReportTabContent,
      },
      {
        label: $localize`:@@alertsReportReport:Informe de alertas`,
        component: this.alertReportTabContent,
      },
    ];
    this.changeDetector.detectChanges();
  }
}
